import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import ProjectDetail from "@/pages/ProjectDetail";
import ProjectWizard from "@/pages/ProjectWizard";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import Partners from "@/pages/Partners";
import VendorProfile from "@/pages/VendorProfile";
import EstimateStudio from "@/pages/EstimateStudio";
import Technology from "@/pages/Technology";
import AdvisoryPlans from "@/pages/AdvisoryPlans";
import AdminEstimate from "@/pages/partner/AdminEstimate";
import AdminPlans from "@/pages/partner/AdminPlans";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import VendorRegister from "@/pages/partner/VendorRegister";
import VendorPortal from "@/pages/partner/VendorPortal";
import StaffLogin from "@/pages/partner/StaffLogin";
import AdminPortal from "@/pages/partner/AdminPortal";
import ManagerPortal from "@/pages/partner/ManagerPortal";
import AdminLeads from "@/pages/partner/AdminLeads";
import AdminCustomers from "@/pages/partner/AdminCustomers";
import AdminTestimonials from "@/pages/partner/AdminTestimonials";
import VDA from "@/pages/vda/VDA";
import GuideSave20 from "@/pages/GuideSave20";
import KnowledgeCenter from "@/pages/kc/KnowledgeCenter";
import { Toaster } from "@/components/ui/sonner";
import ConsultCTA from "@/components/ConsultCTA";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-white"><Loader2 className="h-7 w-7 animate-spin text-[#0E9AC8]" /></div>;
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/about" element={<About />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/guide/save-20-percent" element={<GuideSave20 />} />
      <Route path="/kc" element={<KnowledgeCenter />} />
      <Route path="/partners" element={<Partners />} />
      <Route path="/partner/:id" element={<VendorProfile />} />
      <Route path="/estimate" element={<Protected><EstimateStudio /></Protected>} />
      <Route path="/technology" element={<Technology />} />
      <Route path="/plans" element={<AdvisoryPlans />} />
      <Route path="/admin/estimate" element={<AdminEstimate />} />
      <Route path="/admin/plans" element={<AdminPlans />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/vendor/register" element={<VendorRegister />} />
      <Route path="/vendor" element={<VendorPortal />} />
      <Route path="/login" element={<StaffLogin />} />
      <Route path="/admin" element={<AdminPortal />} />
      <Route path="/manager" element={<ManagerPortal />} />
      <Route path="/admin/leads" element={<AdminLeads />} />
      <Route path="/admin/customers" element={<AdminCustomers />} />
      <Route path="/admin/testimonials" element={<AdminTestimonials />} />
      <Route path="/vda" element={<VDA />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/new-project" element={<Protected><ProjectWizard /></Protected>} />
      <Route path="/project/:id" element={<Protected><ProjectDetail /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <ConsultCTA />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
